// Pairs menu labels with named routes;
// the routes here must match the named routes in router.js
export default [
	{
		route: 'execProtection',
		label: 'Executive Transportation and Protection'
	},{
		route:'secLogistics',
		label:'Security Logistics for Events and Productions'
	},{
		route:'intel',
		label:'Investigations and Intelligence'
	},{
		route:'guard',
		label:'Guard Service Implementation'
	},{
		route:'consulting',
		label:'Consulting and Risk Analysis'
	},{
		route:'talks',
		label:'Talks on Personal Security'
	}
	// {label:'Fraud detection', route:'fraud'},
	// {label:'Logistics for goods', route:'/goods'},
]
